import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error-content-wrap" }
const _hoisted_2 = { class: "error-content" }
const _hoisted_3 = {
  class: "error-content",
  "data-lang": "de"
}
const _hoisted_4 = {
  class: "error-content",
  "data-lang": "en"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"24px"} }, null, -1)
const _hoisted_6 = ["innerHTML"]

import { PropType } from 'vue';
import { Dictionary } from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'TranslatedContent',
  props: {
  lang: {
    type: String,
    required: true,
  },
  title: {
    type: Object as PropType<Dictionary<string>>,
    required: true,
  },
  contactInfo: {
    type: Object as PropType<Dictionary<string>>,
    required: false,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title[__props.lang]), 1),
    _withDirectives(_createElementVNode("div", _hoisted_3, " Sehr geehrte Kunden, aufgrund einer technischen Störung ist unsere Auktionsplattform derzeit nicht erreichbar. Wir arbeiten mit Hochdruck an der Behebung des Problems und werden Sie an dieser Stelle über den weiteren Ablauf der Auktionen informieren. Wir bitten um Ihr Verständnis und danken Ihnen für Ihre Geduld. ", 512), [
      [_vShow, __props.lang === 'de']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, " Dear customers, unfortunately we have to inform you that due to a technical malfunction, our auction platform is currently unavailable. We are working diligently to resolve the issue and will update you here about the further progress of the auctions. We kindly ask for your understanding and thank you for your patience. ", 512), [
      [_vShow, __props.lang === 'en']
    ]),
    _hoisted_5,
    _createElementVNode("div", {
      innerHTML: __props.contactInfo[__props.lang]
    }, null, 8, _hoisted_6)
  ]))
}
}

})